// extracted by mini-css-extract-plugin
export default {"wrapper":"LegalPage_wrapper__4O7Ef"};